module.exports = __webpack_public_path__ + "img/newOrderPc.ef636f79.png";